import React from 'react';

import { Center } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: spacing.$5,
    justifyContent: 'flex-start',
    marginTop: spacing.$0_5,
  },
});

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, style],
  });

export const BadgeWrapper = Center.withConfig<{ $orange: boolean }>(p => ({
  backgroundColor: p.$orange
    ? getDesignToken('alert-info-background')
    : getDesignToken('alert-success-background'),
  minWidth: '$20',
  height: '$5',
  borderRadius: '5px',
}));

export const Badge = withTypography({
  fontSize: 'xs',
  textAlign: 'center',
  fontFamily: 'heading',
  color: primitive.$mayoEggWhite,
  lineHeight: 'xs',
});

export {
  incrementorButtonStyleProps as incrementorStyleProps,
  incrementorDisplayValueStyleProps as displayValueStyleProps,
} from 'pages/loyalty/loyalty-incentives-components/incentive-card/incrementor.styled';
